import styles from "./ImageDetail.module.css";

const DetailsBottomSection = ({ details }) => (
  <div className="container-fluid p-3">
    <div className="row justify-content-between">
      <div className="col-12">
        <div className={styles.bottomSectionDetailsSingle}>
          <span>Contract Address</span>
          <span className={styles.bottomSectionDetailsHighlight}>
            {details ? details.contract_address : ""}
          </span>
        </div>
        <div className={styles.bottomSectionDetailsSingle}>
          <span>Token ID</span>
          <span>{details ? details.token_id : ""}</span>
        </div>
        <div className={styles.bottomSectionDetailsSingle}>
          <span>Token Standard</span>
          <span>{details ? details.token_standard : ""}</span>
        </div>
        <div className={styles.bottomSectionDetailsSingle}>
          <span>Blockchain</span>
          <span>{details ? details.blockchain : ""}</span>
        </div>
        <div className={styles.bottomSectionDetailsSingle}>
          <span>Metadata</span>
          <span>{details ? details.metadata : ""}</span>
        </div>
      </div>
    </div>
  </div>
);

export default DetailsBottomSection;
